$(document).ready(function () {

  //Sliders 
  var $counter = $('.slide-count');
  var $slider = $('.product_hero_slider');
  var $progressBar = $('.progress');
  var $progressBarLabel = $('.slider__label');
  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc);

    $progressBarLabel.text(calc + '% completed');
  });
  $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $counter.text(i + '/' + slick.slideCount);
  });

  $slider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    infinite: false,
    responsive: [
      //        {
      //           breakpoint: 1500,
      //           settings: {
      //             slidesToShow: 2,
      //             slidesToScroll: 1
      //           }
      //         },
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.brand_main').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  $('.gallery_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true
  });

  $('.main_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.nav_slider'
  });

  $('.nav_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.main_slider',
    vertical: true,
    infinite: true,
    verticalSwiping: true,
    focusOnSelect: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.related_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });

  //   $('.product_card_row').slick({
  //        	slidesToShow:2,
  //         slidesToScroll: 1,
  //         autoplay: false,
  //       	arrows:false,
  //     	mobileFirst: true,
  //       	responsive: [
  //         {
  //           breakpoint: 767,
  //           settings: "unslick"
  //         }
  //       ]
  //     });
  //  


  //Mobile Menu
  $('.menu_icon').click(function () {
    $('body').addClass('mob_menu_opened');
  });
  $('.close-btn').click(function () {
    $('body').removeClass('mob_menu_opened');
  });

  $('.mob_main_li a').click(function () {
    var mianLi = $(this).parents('.mob_main_li');
    $(mianLi).find('.submenu_main').slideToggle();
    //       	$(this).toggleClass('active_sub');
    if ($(mianLi).hasClass('active_sub')) {
      $(mianLi).removeClass('active_sub');
    } else {
      $(mianLi).addClass('active_sub');
    }
  });

  //address page
  $(".btn_edit").click(function () {
    $('#AddAddress').hide();
    var formid = $(this).attr("id");
    var form_id = $("#EditAddress_form" + formid);
    $('#main_addresses').hide();
    $(form_id).show();
  });

  $('.btn_cancle').click(function () {
    location.reload();
  });

  var input = document.querySelector('.checkpolices');
  input.oninvalid = function (event) {
    event.target.setCustomValidity('Votre inscription a bien été enregistrée');
  }

  //fillter collection
  setTimeout(function () {
    $("#menu_main_fillter").insertAfter($("div.snize .snize-product-filters-block:last-child"));
    let fillterLinks = $('.all_main-Wrapper').html();
    $(document).on('DOMNodeInserted', function (e) {
      if ($(e.target).hasClass('snize-product-filters-block')) {
        setTimeout(function () {
          $(fillterLinks).insertAfter($("div.snize .snize-product-filters-block:last-child"));
        }, 600);
      }
    });
  }, 1500);

  setTimeout(function () {
    $('.snize-main-panel .snize-main-panel-mobile-filters').click(function () {
      $("#menu_main_fillter").insertBefore($(".snize-product-filters-buttons-container"));
    });

    let fillterLinks = $('.all_main-Wrapper').html();

    $('.snize-modal').click(function (e) {
      setTimeout(function () {
        if ($(".snize-modal-content .menu_wrapper_fillter").length == 0) {
          $(fillterLinks).insertBefore($('.snize-product-filters-buttons-container'));
        }
      }, 600);
    });
  }, 1500);





  //   }

  //copy url
  var $temp = $("<input>");
  var $url = $(location).attr('href');

  $('.copy_page_url').on('click', function () {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    $(this).addClass('copied_link');
    setTimeout(function () {
      $('.copy_page_url').removeClass('copied_link');
    }, 2000);
  });


  //open account Sidebar
  $('.open_side_bar').click(function () {
    $('body').addClass('opened_account_sidebar');
  });


  //active Account menu Page Link
  var url = document.location.href;

  $('.account_menu li a').removeClass('active_page');
  $('.account_menu li a').filter(function () {
    return this.href == url;
  }).addClass('active_page');

  //   	//Sticky Header
  //    	$(window).scroll(function(){
  //       var sticky = $('.Relic_Header'),
  //           scroll = $(window).scrollTop();

  //       if (scroll >= 50) sticky.addClass('sticky_header');
  //       else sticky.removeClass('sticky_header');
  //     });

  //password See
  $('.icon_eye').click(function () {
    if ($(this).hasClass('see-password')) {
      $(this).removeClass('see-password');
      $(this).prev().attr("type", 'password');
    } else {
      $(this).addClass('see-password');
      $(this).prev().attr("type", 'text');
    }
  });

  //Modal popup
  $('.btn_modal').on("click", function () {
    var parentsSection = $(this).parents('.about_video');
    var srcVideo = $('#video_src').val();

    $("#player").attr('src', srcVideo);
    $(parentsSection).find('.video-modal').fadeIn(300);
  });
  $('.modal_close').on("click", function () {
    $(this).parents('.modal_main_wrapper').fadeOut(300);
    $("#player").attr('src', '');
  });

  //product form
  $('.product_form').on('submit', function (e) {
    let ModalProduct = $(this).parents('.product_box').find('.modal_main_wrapper');
    var btnForm = $(this).find('button[type="submit"]');
    var form = $(this).serialize();
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: form
    })
      .then(function (response) {
      })
      .then(data => {
        // console.log('Product Added');
        $(ModalProduct).fadeIn(300);

        setTimeout(function(){
          $('.modal_main_wrapper .slick-slider').each(function(){
            $(this).slick('refresh');
          });
        }, 1000)
      })
  });

  $('body').on('click', '.btn-filter', function () {
    var mainFilterBar = $(this).parents('.product_collection').find('.snize-filters-sidebar');
    $(mainFilterBar).addClass('open_sidebar');
    $('body').addClass('open_filter_sidebar');
  });
  $('body').on('click', '.btn-filter', function () {
    var mainFilterBar = $(this).parents('.page_section').find('.snize-filters-sidebar');
    $(mainFilterBar).addClass('open_sidebar');
    $('body').addClass('open_filter_sidebar');
  });

  $('body').on('click', '.btn-close-filter', function () {
    var mainFilterBar = $(this).parents('.product_collection').find('.snize-filters-sidebar');
    $(mainFilterBar).removeClass('open_sidebar');
    $('body').removeClass('open_filter_sidebar');
  });
  $('body').on('click', '.btn-close-filter', function () {
    var mainFilterBar = $(this).parents('.page_section').find('.snize-filters-sidebar');
    $(mainFilterBar).removeClass('open_sidebar');
    $('body').removeClass('open_filter_sidebar');
  });


  //datepicker register account
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  let qntYears = 70;
  let selectYear = $("#year");
  let selectMonth = $("#month");
  let selectDay = $("#day");
  let currentYear = new Date().getFullYear();

  for (var y = 0; y < qntYears; y++) {
    let date = new Date(currentYear);
    let yearElem = document.createElement("option");
    yearElem.value = currentYear
    yearElem.textContent = currentYear;
    selectYear.append(yearElem);
    currentYear--;
  }

  for (var m = 0; m < 12; m++) {
    let month = monthNames[m];
    let monthElem = document.createElement("option");
    monthElem.value = m;
    monthElem.textContent = month;
    selectMonth.append(monthElem);
  }

  var d = new Date();
  var month = d.getMonth();
  var year = d.getFullYear();
  var day = d.getDate();

  selectYear.val(year);
  selectYear.on("change", AdjustDays);
  selectMonth.val(month);
  selectMonth.on("change", AdjustDays);

  AdjustDays();
  selectDay.val(day)

  function AdjustDays() {
    var year = selectYear.val();
    var month = parseInt(selectMonth.val()) + 1;
    selectDay.empty();

    //get the last day, so the number of days in that month
    var days = new Date(year, month, 0).getDate();

    //lets create the days of that month
    for (var d = 1; d <= days; d++) {
      var dayElem = document.createElement("option");
      dayElem.value = d;
      dayElem.textContent = d;
      selectDay.append(dayElem);
    }
  }


  $("#create_customer").submit(function (e) {
    var customerDay = $('#day').find(":selected").text();
    var customerYear = $('#year').find(":selected").text();
    var customerMonth = $('#month').find(":selected").text();

    console.log(customerDay);
    console.log(customerYear);
    console.log(customerMonth);

    var DateCustomer = customerDay + '/' + customerMonth + '/' + customerYear

    $('#RegisterForm-Dob').val(DateCustomer);
  });


  //Mobile accordion Footer  
  updateContainer();
  $(window).resize(function () {

    updateContainer();
  });

  setTimeout(function () {
    $('.swym-add-to-wishlist-view-product, .wishlist_btn').click(function () {
      if ($(this).hasClass('swym-added')) {
        $(this).removeClass('swym-added disabled swym-adding');
        $(this).addClass('remove_list');
      } else {
        $(this).addClass('swym-added disabled swym-adding');
        $(this).removeClass('remove_list');
      }
    });
  }, 1500);

  $('.search-results-page').find('.main-page-title').text('Résultats de recherche');

});



//calander button
if (window.location.href.indexOf("/pages/evenements") > -1) {
  setTimeout(function () {
    $('.widget-controls-right').find('.subscribe-text-area').text('S’abonner');
    $('.filters-mobile-button-text').find('strong').text('Filtrer');
    $('.bottom-navigation__previous').find('.bottom-navigation__text').text('Précédents événements');
    $('.bottom-navigation__more').find('.bottom-navigation__text').text('Plus d’événements');
    $('.no-events-message').find('>div:nth-child(1)').text('Consultez nos événements précédents.');
    $('.no-events-message').find('>div:nth-child(2)').text("Nous n'avons pas d'événements à venir, mais n'hésitez pas à consulter nos événements passés.");
    $('.subcribe-to-calendar, .subcribe-to-calendar__inverse').click(function () {
      setTimeout(function () {
        $('.filters-container--subscription-options').find('.filters__header').text('Sélectionne ton agenda');
      }, 400);
    });

    $(document).on('DOMNodeInserted', function (e) {
      if ($(e.target).hasClass('search-toggle')) {
        setTimeout(function () {
          SearchPlaceholder();
        }, 400);
      }
      //calendar-popup-translate rsvp
      if ((e.target).querySelectorAll('.rsvp').length) {
          $('.rsvp .rsvp__input-container input[name=name]').attr("placeholder", "Nom");
          $('.rsvp .rsvp__submit').text("S'inscrire");
          $('.rsvp .rsvp__stripe-secure-message').text("Paiement sécurisé");
      }
      if ($(e.target).hasClass('rsvp__input-invalid-message')) {
        //nom
        $('.rsvp .rsvp__input-container input[name=name] ~ .rsvp__input-invalid-message:not(.translated)').text('Un nom est requis');
        $('.rsvp .rsvp__input-container input[name=name] ~ .rsvp__input-invalid-message:not(.translated)').addClass("translated")
        //email
        $('.rsvp .rsvp__input-container input[name=email] ~ .rsvp__input-invalid-message:not(.translated)').text('Une adresse mail est requise');
        $('.rsvp .rsvp__input-container input[name=email] ~ .rsvp__input-invalid-message:not(.translated)').addClass("translated")
        //ticket-types
        $('.rsvp .ticket-types .rsvp__input-invalid-message:not(.translated)').text('Spécifie le nombre de places souhaité')
        $('.rsvp .ticket-types .rsvp__input-invalid-message:not(.translated)').addClass("translated")
      }

      if ($(e.target).hasClass('ReactCollapse--collapse')) {
        console.log('calendar-list-event__header');
        setTimeout(function () {
          InnerbuttonEvent();
          $('.event-subcribe-to-calendar .subscribe-text-area').text('Ajouter à mon calendrier');
          $('.sharing__copy-success').text('Copié dans le presse-papier');
        }, 400);
      }

    });


    $('.filters-mobile-button').click(function () {
      setTimeout(function () {
        var new_structure = $(".filters-container").find(".filters__header").html().replace('Filters', 'Filtres');
        $(".filters-container").find(".filters__header").html(new_structure);
        setTimeout(function () {
          $('.filters__close').click(function () {
            $(this).parents('.filters-container').remove();
          });
        }, 400);
      }, 400);
    });
    var subscribeBtnText = $(".subcribe-to-calendar").find(".subscribe-text-area").html().replace('Subscribe to this calendar', 'S’abonner à cet agenda');
    $(".subcribe-to-calendar").find(".subscribe-text-area").html(subscribeBtnText);

    var PagesummryText = $(".event-summary__pages").html().replace('of', 'sur');
    $(".event-summary__pages").html(PagesummryText);

    $('.list li.eca-flex__center').click(function () {
      setTimeout(function () {
        backEvent();
      }, 700);
    });

  }, 3000);
}

function backEvent() {
  setTimeout(function () {
    $('.fc-event-container').click(function () {
      setTimeout(function () {
        $('.single-event__back__text').text('Retour aux événements');
      }, 400);
    });
  }, 400);
}


function SearchPlaceholder() {
  var textPlaceholder = 'Recherche un événement';
  $('input[name="search"]').attr("placeholder", textPlaceholder);
}

function InnerbuttonEvent() {
  $('.event-subcribe-to-calendar').click(function () {
    setTimeout(function () {
      $('.filters-container--subscription-options').find('.filters__header').text('Sélectionne ton agenda');
    }, 400);
  });
}


function updateContainer() {
  var win = $(window);
  if (win.width() <= 760) {
    $('.nav_ul .main_li:not(.opened)').find('.dropdown_menu').hide();
    $('.nav_ul .main_li').off('click').on('click', function () {
      if ($(this).hasClass('opened')) {
        $(this).removeClass('opened');
        $(this).find('.dropdown_menu').slideUp();
      } else {
        $('.accordion_li').removeClass('opened');
        $('.accordion_li').find('.dropdown_menu').slideUp();
        $(this).addClass('opened');
        $(this).find('.dropdown_menu').slideDown();
      }
    });
  } else {
    $('.nav_ul .main_li').off('click');
    $('.nav_ul .main_li').find('.dropdown_menu').show();
  }

}


//notepad-anchor-title

const init = {
  infinite: false,
  arrows: false,
  dots: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 577,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1,
      }
    }
  ]
};
$(() => {
  const win = $(window);
  const slider = $(".product_card_row");

  win.on("load resize", () => {
    if (win.width() < 767) {
      slider.not(".slick-initialized").slick(init);
    } else if (slider.hasClass("slick-initialized")) {
      slider.slick("unslick");
    }
  });
  // 	$(".product_card_row").slick('setPosition');
});

//card animation
var x;
var $cards = $(".category_box .img_wrapper .img_div");
var $style = $(".hover");

$cards
  .on("mousemove touchmove", function (e) {
    // normalise touch/mouse
    var pos = [e.offsetX, e.offsetY];
    e.preventDefault();
    if (e.type === "touchmove") {
      pos = [e.touches[0].clientX, e.touches[0].clientY];
    }
    var $card = $(this);
    // math for mouse position
    var l = pos[0];
    var t = pos[1];
    var h = $card.height();
    var w = $card.width();
    var px = Math.abs(Math.floor(100 / w * l) - 100);
    var py = Math.abs(Math.floor(100 / h * t) - 100);
    var pa = (50 - px) + (50 - py);
    // math for gradient / background positions
    var lp = (50 + (px - 50) / 1.5);
    var tp = (50 + (py - 50) / 1.5);
    var px_spark = (50 + (px - 50) / 7);
    var py_spark = (50 + (py - 50) / 7);
    var p_opc = 20 + (Math.abs(pa) * 1.5);
    var ty = ((tp - 50) / 2) * -1;
    var tx = ((lp - 50) / 1.5) * .5;
    // css to apply for active card
    var grad_pos = `background-position: ${lp}% ${tp}%;`
    var sprk_pos = `background-position: ${px_spark}% ${py_spark}%;`
    var opc = `opacity: ${p_opc / 100};`
    var tf = `transform: rotateX(${ty}deg) rotateY(${tx}deg)`
    // need to use a <style> tag for psuedo elements
    var style = `
      .category_box .img_wrapper .img_div:hover:before { ${grad_pos} }  /* gradient */
      .category_box .img_wrapper .img_div:hover:after { ${sprk_pos} ${opc} }   /* sparkles */ 
    `
    // set / apply css class and style
    $cards.removeClass("active");
    $card.removeClass("animated");
    $card.attr("style", tf);
    $style.html(style);
    if (e.type === "touchmove") {
      return false;
    }
    clearTimeout(x);
  }).on("mouseout touchend touchcancel", function () {
    // remove css, apply custom animation on end
    var $card = $(this);
    $style.html("");
    $card.removeAttr("style");
    x = setTimeout(function () {
      $card.addClass("animated");
    }, 2500);
  });

// function zoom(e){
//   var zoomer = e.currentTarget;
//   e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
//   e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
//   x = offsetX/zoomer.offsetWidth*100
//   y = offsetY/zoomer.offsetHeight*100
//   zoomer.style.backgroundPosition = x + '% ' + y + '%';
// }

$(document).ready(function () {
  $('.image_zoom_box_src').magnify();



  $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false
  });

  setTimeout(function () {
    var url = document.location.href;
    $('.petamenu li').removeClass('active_link');
    $('.petamenu li a').filter(function () {
      return this.href == url;
    }).parent().addClass('active_link');
  }, 3000);

});


$(function(){
  $('.btn-search').on('click', function(){
    $('.search_wrapper').toggleClass('opened');
  });
  $('.close-search').on('click', function(e){
    $('.search_wrapper').removeClass('opened');
  })
});